// Translations
import form from '../sections/form/translations/en'

// Translation: Two-factor authentication > Landing (English)
export default Object.freeze({
	sections: { form }
})
